import { gql } from "@apollo/client";
import { ButtonBase } from "@mui/material";
import Stack from "atoms/Stack";
import useData from "helpers/useData";
import { FileTableOutline } from "mdi-material-ui";
import Dialog from "molecules/Dialog";
import BoxScore, { BoxScoreFragment, BoxScoreGamePlayerFragment } from "pages/games/BoxScore";
import React, { useState } from "react";

export default function VideoBoxScoreButton({ gameId }) {
  const [open, openSet] = useState(false);
  const [dataOpen] = useData(
    gql`
      query VideoBoxScoreButtonOpen($gameId: ID!) {
        game(id: $gameId) {
          id
          ...BoxScoreFragment
          currentUserDefaultGamePlayer {
            id
            ...BoxScoreGamePlayerFragment
          }
        }
      }
      ${BoxScoreFragment}
      ${BoxScoreGamePlayerFragment}
    `,
    { gameId: gameId },
    { skip: !open },
  );

  return (
    <>
      <Stack padding dense horizontal alignItemsCenter element={<ButtonBase onClick={() => openSet(true)} />}>
        <FileTableOutline />
        <div>Box Score</div>
      </Stack>
      <Dialog open={open} onClose={() => openSet(false)} mediumWidth>
        <BoxScore game={dataOpen?.game} gamePlayer={dataOpen?.game?.currentUserDefaultGamePlayer} />
      </Dialog>
    </>
  );
}
